import { UsersIcon } from "@heroicons/react/24/outline";
import { cn } from "@/lib/utils";

// Monthly bonus thresholds
const BASELINE_TEENS = 21;

interface BonusProgressProps {
  totalMonthlyEligibleTeens?: number;
  className?: string;
  caseload?: number;
}

export function BonusProgress({
  totalMonthlyEligibleTeens = 0,
  caseload = 0,
  className,
}: BonusProgressProps) {
  const eligibleTeens = totalMonthlyEligibleTeens;
  const progressAboveBaseline = Math.max(eligibleTeens - BASELINE_TEENS + 1, 0);
  const progressPercentage = Math.min(progressAboveBaseline * 10, 100);
  const maxBonus = Math.max((caseload - 20) * 60, 0);

  const getProgressMessage = () => {
    if (caseload < BASELINE_TEENS) {
      return `Increase your caseload to ${BASELINE_TEENS}+ teens to unlock your bonus.`;
    }
    if (caseload >= BASELINE_TEENS && totalMonthlyEligibleTeens < caseload) {
      return `Engage ${caseload - totalMonthlyEligibleTeens} more teens to unlock your $${maxBonus} bonus.`;
    }

    return "You've crushed it. All your teens are engaged.";
  };

  return (
    <div className={cn("w-full", className)}>
      <div className="mb-4 flex items-baseline justify-between">
        <span
          className="font-['TWK Lausanne'] font-normal"
          style={{ color: "#19A800" }}
        >
          Bonus: ${progressAboveBaseline * 60}
        </span>
        <span className="font-['TWK Lausanne'] font-normal text-gray-400">
          ${maxBonus}
        </span>
      </div>

      <div className="space-y-3">
        <div className="relative h-2 w-full overflow-hidden rounded-full bg-gray-100">
          <div
            className="font-['TWK Lausanne'] h-full rounded-full transition-all"
            style={{
              width: `${progressPercentage}%`,
              backgroundColor: "#19A800",
            }}
          />
        </div>
        <div className="font-['TWK Lausanne'] flex items-center gap-2 rounded bg-gray-100 p-2 text-sm text-gray-600">
          <UsersIcon className="h-4 w-4 text-gray-400" />
          <span>{getProgressMessage()}</span>
        </div>
      </div>
    </div>
  );
}
